export const lang = {
  nav: {
    '分享给我的': '分享给我的',
    '浏览器管理': '浏览器管理',
    '浏览器列表': '浏览器列表',
    '分组': '分组',
    '回收站': '回收站',
    '我的帐户': '我的帐户',
    '套餐管理': '套餐管理',
    '子帐户管理': '子帐户管理',
    '操作日志': '操作日志',
    '全局设置': '全局设置',
    '应用中心': '应用中心',
    '帮助中心': '帮助中心',
    '推广奖励': '推广奖励',
  },
  comm: {
    '复制成功': '复制成功',
    '未知错误': '未知错误',
    '基础信息': '基础信息',
    '操作系统': '操作系统',
    '浏览器': '浏览器',
    '时区': '时区',
    '位置': '位置',
    '语言': '语言',
    '提供商': '提供商',
    '代理': '代理',

    '汇率计算': '汇率计算',
    '人民币': '人民币',
    '美元': '美元',
    '英镑': '英镑',
    '欧元': '欧元',
    '日元': '日元',
    '加币': '加币',
    '港币': '港币',
    'IP测试': 'IP测试',
    '密码生成': '密码生成',
    '复制安全密码': '复制安全密码',
    '刷新': '刷新',
    '位数': '位数',
    '组成': '组成',
    '小写': '小写',
    '大写': '大写',
    '特殊字符': '特殊字符',
    '你很安全': '你很安全',
    '你很危险': '你很危险',
    '我的IP': '我的IP',
    '开启': '开启',
    '关闭': '关闭',
    '未开启': '未开启',
    '启用': '启用',
    '禁用': '禁用',
    '分辨率': '分辨率',
    '蓝牙': '蓝牙',
    '充电状态': '充电状态',
    '剩余电量': '剩余电量',
    '电量可用时间': '电量可用时间',
    '充电完成所需时间': '充电完成所需时间',
    '指纹保护': '指纹保护',
    '绘图API': '绘图API',
    'Canvas指纹': 'Canvas指纹',
    '图像文件': '图像文件',
    '图像信息': '图像信息',
    '文本API': '文本API',
    '宽': '宽',
    '高': '高',
    '文件大小': '文件大小',
    '字节': '字节',
    '字体指纹': '字体指纹',
    '字体列表': '字体列表',
    '支持': '支持',
    '不支持': '不支持',
    '收起': '收起',
    '查看全部': '查看全部',
    '联网': '联网',
    '断网': '断网',
    '基础': '基础',
    '视频输入设备': '视频输入设备',
    '音频输入设备': '音频输入设备',
    '音频输出设备': '音频输出设备',
    '语言不同': '语言不同',
    '客户端语言与HTTP请求Header中Accept-Language语言不同': '客户端语言与HTTP请求Header中Accept-Language语言不同。',
    '未设置“勿追踪”功能': '未设置“勿追踪”功能。',
    'WebDriver已开启': 'WebDriver已开启',
    'WebDriver是一个支持浏览器自动化的工具，正常浏览器应该是关闭的': 'WebDriver是一个支持浏览器自动化的工具，正常浏览器应该是关闭的。',
    'Cookie已禁用': 'Cookie已禁用',
    'Cookie是储存在用户本地终端上的数据': 'Cookie是储存在用户本地终端上的数据，部分网站为了辨别用户身份进行Session跟踪而储存在用户本地终端上的数据，正常浏览器应该是开启的。',
    '无剩余电量': '无剩余电量',
    '正常电脑或手机正在使用中时应该是有剩余电量': '正常电脑或手机正在使用中时应该是有剩余电量。',
    'SpeechSynthesis未检测出信息': 'SpeechSynthesis未检测出信息',
    'SpeechSynthesis是语音服务的控制接口': 'SpeechSynthesis是语音服务的控制接口，它可以用于获取设备上关于可用的合成声音的信息，正常浏览器此项应该能检测出信息。',
    'HTTP请求时Header未检测出信息': 'HTTP请求时Header未检测出信息',
    'Header为HTTP请求时重要信息': 'Header为HTTP请求时重要信息，也是不可或其他或缺的一部分。',
    '系统字体列表未检测出信息': '系统字体列表未检测出信息',
    '字体检测异常': '字体检测异常',
    '字体列表与当前系统不匹配': '字体列表与当前系统不匹配',
    '系统字体列表每台设备都会拥有': '系统字体列表每台设备都会拥有。',
    '移动端未检测出蓝牙设备': '移动端未检测出蓝牙设备',
    '蓝牙技术是一种无线数据和语音通信开放的全球规范': '蓝牙技术是一种无线数据和语音通信开放的全球规范，它是基于低成本的近距离无线连接，为固定和移动设备建立通信环境的一种特殊的近距离无线技术连接，正常移动端此项应该拥有。',
    'WebRtc未开启': 'WebRtc未开启',
    '经度': '经度',
    '纬度': '纬度',
    '州': '州',
    '国家': '国家',
    '地区': '地区',
    '城市': '城市',
    '媒体设备信息': '媒体设备信息',
    '未检测到设备': '未检测到设备',
    '正在充电': '正在充电',
    '停止停电': '停止停电',
    '浏览器不支持XMLHttpRequest无法检测': '浏览器不支持 XMLHttpRequest 无法检测',
    '安徽铁脚印': '安徽铁脚印',
    'tips1': 'ipcs.vip适用于检查代理IP检测、地址、操作系统版本、UA、webrtc、画布、浏览器指纹、WebRTC泄漏、位置、语言等的检测查询工具网站。',
    'tips2': '该服务的核心功能和主要优势是对Java、Flash和WebRTC的交互式检查，可以发现系统的真实设置和弱点，防止其他资源学习您不想分享的信息。',
    '分享链接': '分享链接',
    '取消': '取 消',
    '复制': '复 制',

    'DNS与IP不在同一地区': 'DNS与IP不在同一地区',
    '你的DNS服务器所在的地区不同于你的IP地址所在的地区': '你的DNS服务器所在的地区(%s)不同于你的IP地址所在的地区(%s)。你可能在隐藏自己的位置。',

    title: '浏览器指纹在线检测网站:代理IP防关联伪装度查询工具',
    keywords: '代理IP伪装度查询,浏览器指纹在线检测,浏览器指纹伪装技术,浏览器指纹修改,webrtc检测,浏览器指纹欺骗工具,浏览器指纹模拟',
    description: 'ipcs.vip适用于检查代理IP检测、地址、操作系统版本、UA、webrtc、画布、浏览器指纹、WebRTC泄漏、位置、语言等的检测查询工具网站。',
    '香港检测': '香港检测',
    'WebRTC检测': 'WebRTC检测',
    '我的': '我的',



  },
}



// WEBPACK FOOTER //
// ./src/i18n/zh.js